var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#117B43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.17 7.25C25.39 7.25 25.5867 7.33333 25.76 7.5C25.92 7.66 26 7.85333 26 8.08V23.92C26 24.1467 25.92 24.34 25.76 24.5C25.5867 24.6667 25.39 24.75 25.17 24.75H11.83C11.61 24.75 11.4133 24.6667 11.24 24.5C11.08 24.34 11 24.1467 11 23.92V21H6.83C6.61 21 6.41333 20.92 6.24 20.76C6.08 20.5867 6 20.39 6 20.17V11.83C6 11.61 6.08 11.4133 6.24 11.24C6.41333 11.08 6.61 11 6.83 11H11V8.08C11 7.85333 11.08 7.66 11.24 7.5C11.4133 7.33333 11.61 7.25 11.83 7.25M11 17.06L12.18 19.28H13.97L12 16.06L13.93 12.89H12.22L11.13 14.9L11.09 14.96L11.06 15.03C10.8867 14.6767 10.7 14.32 10.5 13.96C10.3333 13.6067 10.1567 13.25 9.97 12.89H8.16L10.05 16.08L8 19.28H9.78M17.88 23.5V21H12.25V23.5M17.88 19.75V16.63H16V19.75M17.88 15.38V12.25H16V15.38M17.88 11V8.5H12.25V11M24.75 23.5V21H19.13V23.5M24.75 19.75V16.63H19.13V19.75M24.75 15.38V12.25H19.13V15.38M24.75 11V8.5H19.13V11H24.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.ba9928da232fe5f6d98c3c7e684a01c7.svg";
export { ForwardRef as ReactComponent };